export const environment = {
    name: 'd2x',
    angularUrl: 'http://127.0.0.1:4200',
    nestjsUrl: 'http://127.0.0.1:3000',
    pythonUrl: 'https://api.clipperstudio.ai'
};